"use client";

import { startAnalytics } from "../../helpers/analytics";
import { env } from "../../helpers/env.mjs";
import { SubAssetType } from "../../helpers/getSubAssetType";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";

export const Analytics = ({
  gtmSource,
  gtmTemplate,
  title,
  localeString,
  subAssetType,
}: {
  gtmSource: string | null;
  gtmTemplate?: string | null;
  title?: string | null;
  localeString: string;
  subAssetType: SubAssetType | null;
}) => {
  const route = usePathname();

  const hasGtmContainer =
    env.NEXT_PUBLIC_HAS_GTM_CONTAINER && localeString !== "ne-xt";

  useEffect(() => {
    startAnalytics({
      gtmSource,
      gtmTemplate: gtmTemplate ?? "",
      title: title ?? window?.location.href ?? null,
      route: route ?? "",
      localeString,
      subAssetType,
    });
  }, [gtmSource, gtmTemplate, title, route, localeString, subAssetType]);

  return hasGtmContainer ? (
    <>
      <Script async src="//qm.redbull.com/gtm.js?id=GTM-TCZQX4" />
      <Script async src="//qm.redbull.com/gtm.js?id=GTM-5XHDS9" />
    </>
  ) : null;
};
